import React, { useState, useEffect } from 'react';
import { Form, useToast, useWindowSize } from 'vindi-ds-components';
import useToggle from '@hooks/feature_toggles';
import api from '@services/api';
import normalizeMetafield from '@utils/normalizeMetafield';
import Header from './components/header';
import PhoneForm from './components/phone_form';
import RenderSection from './components/render_section';
import RenderCustomFields from './components/render_custom_fields';
import Button from './components/button_submit';
import { validationSchema, initialValues } from './utils/form';
import buildTelephone from './utils/telephone';
import templates from './templates.json';

const normalizePhoneAttributes = (values) => {
  // eslint-disable-next-line camelcase
  const { phones_attributes, ...valuesWithoutPhoneAttributes } = values;
  const filteredPhones = phones_attributes.filter((p) => p.local.length > 0);

  if (filteredPhones.length > 0) {
    const phones = { ...filteredPhones.map((phone) => buildTelephone(phone)) };
    return {
      ...valuesWithoutPhoneAttributes,
      phones_attributes: phones,
    };
  }

  return valuesWithoutPhoneAttributes;
};

const normalizeValues = (values) => {
  const valuesPhonesNormalized = normalizePhoneAttributes(values);
  const valuesMetafieldsNormalized = normalizeMetafield(valuesPhonesNormalized);
  return valuesMetafieldsNormalized;
};

function createCustomer(data, notify) {
  api.post('/admin/customers', { customer: data })
    .then((response) => { window.location.assign(`/admin/customers/${response.data.id}`); })
    .catch(() => {
      notify('Error no servidor', { severity: 'error' });
    });
}

function CustomerNew() {
  const { isMobile } = useWindowSize();
  const showToast = useToast();
  const toggleActive = useToggle('new_ds_customers');
  if (!toggleActive) { return <></>; }

  const handleSubmit = (values) => {
    const data = normalizeValues(values);
    createCustomer(data, showToast);
  };

  return (
    <>
      <Header />
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues(isMobile)}
        validationSchema={validationSchema}
      >
        {({ values }) => (
          <>
            <Sections values={values} />
            <Button />
          </>
        )}
      </Form>
    </>
  );
}

function Sections({ values }) {
  const [customFields, setCustomFields] = useState({});
  const sections = ['informations', 'phones', 'address', 'others_informations'];

  useEffect(() => {
    api
      .get('/admin/customers/new')
      .then((response) => setCustomFields(response.data.metafield));
  }, []);

  return (
    <>
      {
        sections.map((section) => (
          <RenderSection
            key={section}
            title={templates.sections[section].title}
            subtitle={templates.sections[section].subtitle}
            fields={templates.sections[section].fields}
            form={section === 'phones' && PhoneForm}
            values={values}
          />
        ))
      }
      {customFields?.length > 0 && <CustomFields customFields={customFields} />}
    </>
  );
}

function CustomFields({ customFields }) {
  return (
    <RenderCustomFields
      title='Campos Personalizados'
      customFields={customFields}
    />
  );
}

export default CustomerNew;
